export var Currency;
(function (Currency) {
    Currency["CURRENCY_WITH_DECIMAL"] = "$0,0.00";
    Currency["CURRENCY_WITHOUT_DECIMAL"] = "$0,0";
    Currency["CURRENCY_ABBREVIATED"] = "$0a";
})(Currency || (Currency = {}));
